import '../../../src/styles/mine.css'
import Header from './sub-components/Header';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import { auth, db } from './firebase/firebase';
import { doc, setDoc, getDocs, collection, query, updateDoc, where, addDoc } from "firebase/firestore";
import { de_encrypt, encrypt } from '../../encryption';
import { useNavigate } from "react-router-dom"
import BaseNav from './sub-components/BaseNav';
const Mine = () => {
    const user_id = de_encrypt(localStorage.getItem('user-key'));
    const [user, setUser] = useState(null);
    const [isMining, setIsMining] = useState(null);
    const [mils, setMils] = useState(0);
    const [hour, setHour] = useState('0')
    const [min, setMinute] = useState('0')
    const [sec, setSec] = useState('0')
    const [exec, setExec] = useState(false)
    const navigate = useNavigate()
    const addZeros = (n) => {
        return n < 10 ? `0${n}` : n
    }

    console.log(new Date('May 30, 2020 12:00:00').getTime())
    if (isMining == true) {
        if (mils != 0) {
            setInterval(() => {
                const dif = mils - Date.now();
                if (dif > 0) {
                    setHour(Math.floor(dif % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
                    setMinute(Math.floor(dif % (1000 * 60 * 60) / (60 * 1000)))
                    setSec(Math.floor(dif % (1000 * 60) / 1000))
                } else {
                    setIsMining(false)
                }

            }, 1000)
        }
    }
    const mine_duration = (package_type)=>{
        var duration;
        switch(package_type){
           case "starter":
              duration=1;
            break;
           case "premium":
            duration = 1;
            break;
           case "premium pro":
            duration=3;
           break;
           case "elite":
               duration=3;
            break;
            case "expert":
             duration=24;
            break 
            case "worker":
                duration=24;
            break          
        }
        return duration
    }
    const start_mining = async () => {
        if (localStorage.getItem(encrypt("adSession")) == undefined) {
            const today = new Date()
            const adSession = { date: today.getDate(), adsViewed: [] }
            localStorage.setItem(encrypt("adSession"), encrypt(JSON.stringify(adSession)));
            alert("To continue mining you must engage in three ads in the marketplace");
            navigate("/dashboard/marketplace");
        } else {
            const today = new Date();
            const adSession = JSON.parse(de_encrypt(localStorage.getItem(encrypt("adSession"))));
            if (adSession.date != today.getDate()) {
                const today = new Date()
                const adSessionNew = { date: today.getDate(), adsViewed: [] }
                localStorage.setItem(encrypt("adSession"), encrypt(JSON.stringify(adSessionNew)));
                alert("To continue mining you must engage in three ads in the marketplace");
                navigate("/dashboard/marketplace");
            }
            if (adSession.adsViewed.length <= 2) {
                alert(`To continue mining you must engage in ${3 - adSession.adsViewed.length} more ads in the marketplace`);
                navigate("/dashboard/marketplace");
            }
            if (adSession.adsViewed.length >= 3) {
                if (user.mining == false) {
                    setIsMining(true)
                    const userRef = doc(db, "user", user_id);
                    await updateDoc(userRef, {
                        mining: true,
                        no_mines: user.no_mines + 1,
                        minining_starts_at: Date.now(),
                        mining_ends_at: Date.now() + (mine_duration(user.package_type) * 3600 * 1000)
                    });
                    setMils(Date.now() + (mine_duration(user.package_type) * 3600 * 1000))


                    const notification_data = {
                        type: "mine",
                        subject: "You have started mining",
                        body: `Your mining ends in the ${user.mine_duration} hour`,
                        time: Date.now(),
                        to: user_id
                    }
                    const docRef = await addDoc(collection(db, "notifications"), notification_data)
                }

            }
        }

    }
    useEffect(() => {
        if (user == null) {
            (async () => {
                const q = query(collection(db, "user"), where("email", "==", user_id));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach(async (doc) => {
                    setUser(doc.data())
                    setIsMining(doc.data().mining)
                    setMils(doc.data().mining_ends_at);
                });
            })()
        }

    }, [user])
    if (user != null && isMining == true && !exec) {
        if (Date.now() >= user.mining_ends_at && user.mining_ends_at != 0) {
            (async () => {
                const userRef = doc(db, "user", user_id);
                await updateDoc(userRef, {
                    mining: false,

                    minining_starts_at: 0,
                    mining_ends_at: 0,
                    mine_balance: user.mine_balance + user.mine_earning
                });
                const notification_data = {
                    type: "mine",
                    subject: "Mining just ended",
                    body: `An amount of #${user.mine_earning} has been added to your total balance`,
                    time: Date.now(),
                    to: user_id
                }
                const docRef = await addDoc(collection(db, "notifications"), notification_data);
                setIsMining(false)
                setExec(true);

            })()
        }
    }

    // setInterval(()=>{
    //   setSec(new Date().getSeconds())
    // },1000)
    if (user) {
        return (
            <div className="dashboard mine-container utility">
                <Header />
                <BaseNav active={"Mine"} />
                {user && <div className="container">
                    <div className="mine-box">
                        <h1>{`${addZeros(hour)}:${addZeros(min)}:${addZeros(sec)}`}</h1>
                    </div>
                    <div className="btn">
                        {!isMining && <Button variant="contained" style={{ backgroundColor: "#9900EF" }} onClick={start_mining}>Start Mining</Button>}
                        {isMining && <Button variant="contained" style={{ backgroundColor: "#9900EF" }}>Mining...</Button>}
                    </div>

                </div>
                }


            </div>
        );
    } else {
        return (
            <div className="loader-container">
                <div className="loader-header bg-w">
                    <div className="container">
                        <div className="loader-header-top loader-element"></div>
                        <div className="loader-header-bottom loader-element"></div>
                    </div>
                </div>
                <div className="loader-main bg-ws">
                    <div className="loader-mine-box">
                        <div className="loader-mine-time loader-element"></div>
                        <div className="loader-mine-btn loader-element"></div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Mine;
